$(document).ready(function(){

    // main slider
    $('.js-slider').on('init reInit afterChange', function() {
        $('.slick-slide:not(.slick-current) .slider__text').removeClass('slider__text--visible');
        $('.slick-slide:not(.slick-current) .slider__button').removeClass('slider__button--visible');
        $('.js-slider .slick-current  .slider__text').addClass('slider__text--visible');
        $('.js-slider .slick-current  .slider__button').addClass('slider__button--visible');
    });
    $('.js-slider').slick({
        arrows: true,
        speed: 700,
        fade: true,
        autoplay: true,
        autoplaySpeed: 7000,
		dots: true
    });

    // offer slider
    $('.js-offerSlider').slick({
        arrows: true,
        speed: 700,
        //fade: true,
        autoplay: true,
        autoplaySpeed: 7000,
        dots: true,
        slidesToScroll: 4,
        slidesToShow: 4,
        responsive: [
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                arrows: false
              }
            },
            {
                breakpoint: 700,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                  arrows: false
                }
              },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false
              }
            }
          ]
    });

    AOS.init();

    // scrolled menu
	if ($(window).width()<1240){
            $('.js-top').addClass('top--scrolled');
    } else {
        $('.js-top').removeClass('top--scrolled');
    }

    // relax init
    if ($('.rellax').length) {
        var rellax = new Rellax('.rellax');
    }

    // js-up
    $(".js-up").on("click", function () {
        var body = $("html, body");
        body.stop().animate({scrollTop: 0}, 1500, 'swing');
    });

    // go form
    $(".js-goForm").on("click", function () {
        var body = $("html, body");
        body.stop().animate({scrollTop: $('.form').offset().top - 100 }, 1500, 'swing');
    });

    if ( $('.js-goForm').length && $('.formErrors__item.false').length || $('.js-goForm').length && $('.formErrors__item.success').length || $('.js-goForm').length && $('.formErrors__item.error').length ) {
        var body = $("html, body");
        body.stop().animate({scrollTop: $('.form').offset().top - 100 }, 1500, 'swing');
    }


    if ($(window).scrollTop() < 500) {
        $(".js-goForm").addClass("visible");
    }


    //language
    $('.js-language .language__item.active').on('click', function() {
        $(this).parent().toggleClass('active');
        return false;
    });

    //bottomArrow
    $('.js-bottomArrow').on('click', function(){
        var anchor = $(this).attr('data-to');
        $('html, body').animate({
            scrollTop:  $(anchor).offset().top
        }, 1000);
    });

    //search
    $('.js-top__search').on('click', function(){
        $('.top__searchBox').slideToggle('fast');
    });

    if(typeof jsPDF !== "undefined"){
      doc = new jsPDF();
      pdfHandlers = {
          '#pdfContainer': function (element, renderer) {
              return true;
          }
      };
    }

    $("#generatePdf").bind("click",function(){
      if(typeof jsPDF !== "undefined"){
        const filename  = $('title').html() + '.pdf';
        //document.getElementsByClassName("product")[0]
        html2canvas(document.body).then(canvas => {
          //document.body.appendChild(canvas);
          //let pdf = new jsPDF('p', 'mm', 'a4');
          let pdf = new jsPDF();
          pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, 211, 298);
          pdf.save(filename);
          //$("canvas").remove();
        });
      }



    });

}); // end document ready

$(window).on("scroll", function () {

	// js-up
	var scroll = $(window).scrollTop();
	if (scroll > 600) {
			$(".js-up").addClass("visible");
	} else {
			$(".js-up").removeClass("visible");
    }

    if (scroll > 500) {
        $(".js-goForm").removeClass("visible");
    } else {
        $(".js-goForm").addClass("visible");
    }

	// scrolled menu
	if ($(window).scrollTop() > 0){
		$('.js-top').addClass('top--scrolled');
 	} else {
		if ($(window).width()>1240){
			$('.js-top').removeClass('top--scrolled');
		}
    }

}); // end onscroll
